// @flow

import { fontWeight } from 'seedling/constants';
import { type FontWeight, padding } from 'seedling/constants';
import React, { useMemo } from 'react';
import styled from 'styled-components';

export type CheckboxWithLabelProps = {
  checked: boolean,
  labelFontWeight: FontWeight,
  label: string,
  name?: string,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => mixed,
  disabled: boolean,
  className?: string,
};

function CheckboxWithLabel(props: CheckboxWithLabelProps) {
  const {
    labelFontWeight,
    label,
    checked,
    onChange,
    disabled,
    className,
    ...otherProps
  } = props;

  const name = useMemo(() => props.name || `checkbox-${Math.random()}`, [
    props.name,
  ]);

  return (
    <Container className={className}>
      <Checkbox
        id={name}
        name={name}
        value={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...otherProps}
      />
      <Label htmlFor={name} fontWeight={labelFontWeight} disabled={disabled}>
        {label}
      </Label>
    </Container>
  );
}

CheckboxWithLabel.defaultProps = {
  checked: false,
  disabled: false,
  labelFontWeight: 'normal',
};

export default CheckboxWithLabel;

const Container = styled.div`
  display: flex;
  align-items: baseline;
`;

const Label = styled.label`
  font-size: 14px;
  user-select: none;
  margin-left: ${padding.tiny};
  ${props => fontWeight(props.fontWeight)};
  cursor: ${props => (!!props.disabled ? 'default' : 'pointer')};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin: 0;
  cursor: ${props => (!!props.disabled ? 'default' : 'pointer')};
`;
Checkbox.displayName = 'Checkbox';

Label.defaultProps = {
  fontWeight: 'normal',
  disabled: false,
};
